<tax-page-header>
  <tax-tabs [tabs]="tabs"></tax-tabs>
</tax-page-header>

<tax-subscriptions-filter
  class="filter-group"
  (applyFilter)="getSubscriptions($event)"
></tax-subscriptions-filter>

<div class="subscriptions-list" *ngIf="subscriptions.length > 0">
  <div class="list-header">
    <div class="kkm-header" translate>common.concept.kkm</div>
    <div translate>common.concept.retail.place</div>
    <div translate>tariffs.subscribe</div>
    <div class="prolongation-header">
      А
      <tax-icon
        name="help-outline"
        class="icon grey-icon"
        [matTooltip]="'tariffs.subscribe.auto.prolongation' | translate"
        matTooltipPosition="above"
      ></tax-icon>
    </div>
    <div translate>tariffs.subscribe.action</div>
  </div>

  <div *ngFor="let subscription of subscriptions; trackBy: trackByFn" class="list-item">
    <div class="kkm-info">
      <tax-icon
        [name]="getIconName(subscription)"
        [matTooltip]="'status.registration.' + subscription.regStatus | translate"
        matTooltipPosition="above"
        class="kkm-icon grey-icon"
      ></tax-icon>
      <div class="info">
        <a routerLink="/main/kkms/{{ subscription.kkmId }}" class="ui-kit-break-all">{{
          subscription.internalName
        }}</a>
        <span class="ui-kit-grey-text">id: {{ subscription.kkmId }}</span>
      </div>
    </div>
    <div class="retail-place-info">
      {{ subscription.retailPlaceTitle }}
      <span class="ui-kit-grey-text">{{ subscription.retailPlaceAddress }}</span>
    </div>
    <div
      [class.ui-kit-error-text]="
        !subscription.tariffId || !subscription.isAutoRenewableSubscription
      "
    >
      {{ tariffs[$any(subscription.tariffId)]?.name || ('tariffs.subscribe.absent' | translate) }}
    </div>
    <div class="prolongation-column">
      <tax-switch
        [active]="subscription.isAutoRenewableSubscription"
        [disabled]="!subscription.availableOperations.toggleRenewal"
        [matTooltip]="
          !subscription.availableOperations.toggleRenewal
            ? ('tariffs.subscription.renewable.toggle.tooltip' | translate)
            : null
        "
        matTooltipPosition="above"
        (click)="updateAutoProlong(subscription)"
      ></tax-switch>
    </div>
    <div class="actions-info">
      <div
        class="ui-kit-like-link"
        *ngIf="!subscription.tariffId && subscription.availableOperations.selectTariff"
        translate
        (click)="goToSelectSubscriptionPage(subscription.kkmId)"
      >
        button.select
      </div>
      <div
        class="ui-kit-like-link"
        *ngIf="subscription.availableOperations.activateTariff"
        [taxOpenActivateSubscriptionModal]="getDataToSubscription(subscription)"
        (subscriptionActivated)="getSubscriptions(filter)"
        translate
      >
        button.activate
      </div>
      <div
        class="ui-kit-like-link"
        *ngIf="subscription.tariffId && subscription.availableOperations.changeTariff"
        translate
        (click)="goToSelectSubscriptionPage(subscription.kkmId)"
      >
        button.change
      </div>
    </div>
  </div>
</div>

<div class="load-more" *ngIf="subscriptions.length < totalItems">
  <span class="button" (click)="getMoreSubscriptions()">{{ 'button.load.more' | translate }}</span>
</div>
